 import { Box } from '@mui/material';

import ChatWidget from '../components/ChatWidget';
import ForcedDarkModeBanner from '../components/common/ForcedDarkModeBanner';
import WhatsAppButton from '../components/common/WhatsAppButton';
import CompareFloatingBar from '../components/CompareFloatingBar';
import Footer from '../components/layout/Footer';
import Header from '../components/layout/Header';
import HeaderInfoBar from '../components/layout/HeaderInfoBar';
import MobileBottomNav from '../components/layout/MobileBottomNav';

export default function B2CLayout({ children }) {
  return (
    <Box sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      // Prevent horizontal scroll from elements extending beyond viewport
      overflowX: 'hidden',
      maxWidth: '100vw',
    }}>
      <HeaderInfoBar />
      <Header userType="b2c" />
      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>
      <Footer />
      <WhatsAppButton />
      <CompareFloatingBar />
      <ForcedDarkModeBanner />
      <MobileBottomNav />
      <ChatWidget />
    </Box>
  );
}
